import { Layout, Select } from 'antd'
// import logo from 'assets/img/KLSeisⅡ.png'
import './LoginLayout.scss'
import { useTranslation } from 'react-i18next'
import { Card } from 'layouts'
import { useEffect } from 'react'
import $ from 'jquery'
import { setStroage, getStroage } from 'utils'
import i18n from 'i18next'
import { useContextConsumer } from 'context/loginAuthProvider'

export const LoginLayout = ({ children }) => {
    const language = getStroage('language')
    const { t } = useTranslation()
    const themeColor = getStroage('themeColor')
    const { theme } = useContextConsumer() // 登录权鉴

    if(!themeColor){
        theme('blue')
    }

    /* 切换语言、主题 */
    const changLanguage = () => {
        const result = language === 'en'
        if (result) {
            i18n.changeLanguage('zh')
            setStroage('language', 'zh')
        } else {
            i18n.changeLanguage('en')
            setStroage('language', 'en')
        }
    }

    useEffect(() => {
        $('.login').animate({ backgroundSize: 160 + '% ' + 160 + '%' }, 400, 'linear')
    }, [])

    return (
        <Layout className='login'>
            <div className='logo'>
                <div className='left'>
                    {/* <Image height={42} src={logo} preview={false} /> */}
                    {/* <span className='logo-title'>KL-MegaShare</span> */}
                </div>
                {/* 切换语言 */}
                <Select
                    onChange={changLanguage}
                    options={[
                        { value: 'en', label: 'English' },
                        { value: 'zh', label: '简体中文' },
                    ]}
                    className='langIcon'
                    value={language}
                />
            </div>

            <div className='slogan'>
                <div className='content'>
                    <div className='title'>{t('login.slogan')}</div>
                    <div className='disc'>{t('login.disc')}</div>
                </div>
            </div>
            <div className='version'>{/* <p>©2022 BGP INC., CNPC. All rights reserved.</p> */}</div>
            <Card className='login-card'>
                {/* <div className='title'>{t('login.title')}</div> */}
                <div className='from'>{children}</div>
            </Card>
            {/* <Layout.Content></Layout.Content> */}
        </Layout>
    )
}
